<h3 class="prim-card__title">
  <span class="prim-card__title-icon">
    <i class="fa-solid fa-star"></i>
  </span>
  {{ titleKey | translate }}
</h3>

<div class="prim-stickers">
  @for (badge of badges; track $index) {
    <div class="prim-sticker"
         [class.is-locked]="badge.locked"
         [style.background]="badge.locked ? 'var(--cdark9)' : badge.color"
         [title]="badge.i18nKey | translate:badge.i18nParams">
      <i [class]="badge.locked ? 'fa-solid fa-lock' : badge.icon"></i>
    </div>
  }
</div>

<div class="prim-badges__note">
  <i class="fa-solid fa-circle-info"></i>
  {{ noteKey | translate }}
</div>
